import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getIndexMetricData, getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";
import MetricBarChart from "../charts/MetricBarChart";
import RaceEthnicityBarChartCard from "../charts/RaceEthnicityBarChartCard";
import AgeByGenderChart from "../charts/AgeByGenderChart";

const DemographicMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Demographic data:", sortedMetrics);

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the current tab index metric data and id
    const { indexMetricId, indexMetricData } = getIndexMetricData(tab, metadata, indicators);

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const demoOne: DisaggregatedMetric[] = sortedMetrics[0];
    console.log('demo one:', demoOne)
    const demoTwo: DisaggregatedMetric[] = sortedMetrics[1];
    const immigration = indicators.find(i => i.id === 1291);
    const race = indicators.find(i => i.id === 1293);
    const female = indicators.find(i => i.id == 1289);
    const male = indicators.find(i => i.id == 1290);

    return (
        <>
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
            
            <p className="text-[10px] text-port-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-port-text mx-4 text-[10px]">Data updates published March 30, 2026.</p>
            <p className="text-xs text-port-text mx-6 mt-2">Indicators shown below depict demographic details for the population within the selected area.</p>

            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {demoOne.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    {race && (
                        <div className="col-span-2 w-full">
                            <RaceEthnicityBarChartCard
                                raceMetric={race}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                                height="h-56"
                                background="bg-white"
                                barColor="#1a3a67"
                            />
                        </div>
                    )}

                    {demoTwo.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    {immigration && 
                    <div className="w-full mt-2 col-span-2">
                        <MetricBarChart 
                            metric={immigration} 
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            height="h-40" 
                            background="bg-white"
                            barColor="#1a3a67"
                            topFive={true}
                        />
                    </div>
                    }

                    {female && male &&
                    <div className="w-full mt-2 col-span-2">
                        <AgeByGenderChart
                            maleMetric={male}
                            femaleMetric={female}
                            metadataMetricId={1294}
                            title="Age & Gender"
                            subtitle="Population by age group"
                            maleColor="#1a3a67"
                            femaleColor="#9d1d1f"
                            height="h-60"
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showMetadataIcon={true}
                        />
                    </div>
                    }  
                </div>
            </div>
        </>
    );
}

export default DemographicMetrics;